import React from 'react';
import PropTypes from 'prop-types';
import { InlineShareButtons } from 'sharethis-reactjs';

const SocialSharing = ({ url, title, description, alignment }) => (
  <div eb-test="ee_notificationDetail_field_shareButtons">
    <InlineShareButtons
      config={{
        alignment, // alignment of buttons (left, center, right)
        color: 'social', // set the color of buttons (social, white)
        enabled: true, // show/hide buttons (true, false)
        font_size: 10, // font size for the buttons
        labels: 'null', // button labels (cta, counts, null)
        language: 'en', // which language to use (see LANGUAGES)
        networks: [ // which networks to include (see SHARING NETWORKS)
          'facebook',
          'twitter',
          'reddit',
          'email'
        ],
        padding: 8, // padding within buttons (INTEGER)
        radius: 4, // the corner radius on each button (INTEGER)
        show_total: false,
        size: 32, // the size of each button (INTEGER)
        url,
        description,
        title,
      }}
    />
  </div>
)

SocialSharing.propTypes = {
  url: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  alignment: PropTypes.string,
};

SocialSharing.defaultProps = {
  url: '',
  title: '',
  description: '',
  alignment: 'left',
};

export default SocialSharing;
